import React, {useEffect, useState} from 'react'
import {IonContent, IonIcon, IonModal, IonPage, IonToolbar} from '@ionic/react'
import {useHistory} from 'react-router-dom';
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import { chevronBack } from 'ionicons/icons';
import { LeaseForm } from "./LeaseForm"
import { OperationsForm } from "./OperationsForm"
import { NewPacketForm } from './NewPacketForm';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronRight, FolderDocIcon } from '../components/icons';
import { useLogPageVisit } from '../utils/logPageVisit';

function Contracts() {
    useLogPageVisit('LP Contracts', 'User viewed the Contracts page');
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [driverHash, setDriverHash] = useState('')
    const [noDocFound, setNoDocFound] = useState(false);
    const [signedOperations, setSignedOperations] = useState(false);
    const [signedLease, setSignedLease] = useState(false);
    const [signedNewPacket, setSignedNewPacket] = useState(false);
    const [docURL, setDocURL] = useState("");
    const [viewModal, setViewModal] = useState("");
    const [editModal, setEditModal] = useState("");

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.getDriverSsn('contracts').then(it => {
            setDriverHash(it);
            openLeaseAgreement();
            openSignedAgreement();
            openNewPacket();
            checkLink(it);
        });
    }, []);

    const checkLink = (link: any) => {
        const requestOptions = {
            method: 'GET',
            headers: {}
        };
        fetch('https://westernexpressmobile.com/agreements/' + link + "-0.pdf", requestOptions)
        .then(response => {
            if (response.status === 404) {
                setNoDocFound(true);
            }
        })
        .catch(() => {
            setNoDocFound(true);
        })
    }

    const agreementHandler = () => {
        if (noDocFound) {
            toastStore.getState().setToast('No Contract Found');
        } else {
            window.open('https://westernexpressmobile.com/agreements/' + driverHash + "-0.pdf", '_blank')
        }
    }

    const openLeaseAgreement = () => {
        ApiService.agreementDataGet('lease contract', {ownerCode: localStorage.getItem('username')!, contractType: "leaseagreement"})
        .then(it => {
            setSignedLease(checkForData(it));
        })
        .catch(it => {
            console.log(it)
        })

    }

    const openSignedAgreement = () => {
        ApiService.agreementDataGet('operations contract', {ownerCode: localStorage.getItem('username')!, contractType: "operations"})
        .then(it => {
            setSignedOperations(checkForData(it));
        })
        .catch(it => {
            console.log(it)
        })
    }

    const openNewPacket = () => {
        ApiService.agreementDataGet('newdriver contract', {ownerCode: localStorage.getItem('username')!, contractType: "newdriver"})
        .then(it => {
            setSignedNewPacket(checkForData(it));
        })
        .catch(it => {
            console.log(it)
        })
    }

    const checkForData = (results: any) => {
        if (results.data !== undefined) {
            return true;
        } else {
            return false
        }
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/docs');
    };

    const agreements = [
        { key: 'lease', title: 'Lease Agreement', signed: signedLease },
        { key: 'operations', title: 'Hauling Agreement', signed: signedOperations },
        { key: 'newpacket', title: 'New Driver Packet', signed: signedNewPacket },
    ];

    return (
        <IonPage style={{overflowY: "scroll"}}>
            <LoadDetailHeader title="Contracts" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
                <IonModal isOpen={editModal !== ""} id="contractModal">
                    <div className="safety-media-modal">
                        <div className="safety-media-modal__header">
                            <button type="button" className="safety-media-modal__back" onClick={() => setEditModal("")}>
                                <IonIcon icon={chevronBack} style={{ fontSize: '18px' }} />
                                Back
                            </button>
                        </div>
                        <div className="safety-media-modal__body">
                            {editModal === "lease" ?
                                <LeaseForm /> : editModal === "operations" ? <OperationsForm/> : <NewPacketForm/>
                            }
                        </div>
                    </div>
                </IonModal>

                <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                    <div className="home-hero advance-hero">
                        <div className="advance-hero__eyebrow">Docs &amp; Resources</div>
                        <div className="advance-hero__title home-display">Contracts</div>
                        <div className="advance-hero__meta">{agreements.length} agreements on file</div>
                    </div>

                    <div className="home-sheet payroll-sheet">
                        <section className="safety-section">
                            <h2 className="safety-section__title home-section-label">Your agreements</h2>
                            <div className="safety-doc-list">
                                {agreements.map((agreement, index) => (
                                    <button
                                        key={agreement.key}
                                        type="button"
                                        className="safety-doc-row"
                                        style={{ ['--safety-delay' as string]: `${0.35 + index * 0.04}s` }}
                                        onClick={() => setEditModal(agreement.key)}
                                    >
                                        <span className="safety-doc-row__icon" aria-hidden="true">
                                            <FolderDocIcon size={18} />
                                        </span>
                                        <span className="safety-doc-row__label">{agreement.title}</span>
                                        <span
                                            className="trip-tile__tag"
                                            style={agreement.signed ? { color: 'var(--home-text-muted)' } : undefined}
                                        >
                                            {agreement.signed ? 'View' : 'Sign Doc'}
                                        </span>
                                        <ChevronRight color="oklch(0.55 0.01 260)" />
                                    </button>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default Contracts
